import React, { useEffect, useRef, useState } from 'react';
import './manage-lottery-landing.styles.scss';
import { Route, Routes, useNavigate } from 'react-router-dom';
import LotteryList from './lottery-list.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket } from '@fortawesome/free-solid-svg-icons';
import LotteryView from './lottery-view.component';
import { getCollectionFromDb, getLotteryDataFromDb } from '@/utils/getDataFromDb';
import { off } from 'firebase/database';

const ManageLotteryLanding = ({
    gameData,
    playerList,
    gameStats,
    gameElements
}) => {

    const [ lotteriesToDisplay, setLotteriesToDisplay ] = useState([]);
    const [ ticketLists, setTicketLists ] = useState({});
    const lotteryRef = useRef({});
    let ticketListsListener;
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            if (ticketListsListener) off(ticketListsListener);
        }
    }, [])

    useEffect(() => {
        if (!gameData) return;
        getLotteriesToDisplay();
        getTicketLists();
    }, [gameData]);

    function getLotteriesToDisplay() {
        getCollectionFromDb({
            "collection": `games/${gameData.gameId}/gameElements`,
            "query1": {
                "key": "opt_itemType",
                "condition": "==",
                "value": "lottery"
            },
            "query2": {
                "key": "status",
                "condition": "==",
                "value": "active"
            },
            "once": true,
            "callback": callback
        })
        function callback(data) {
            console.log(data);
            lotteryRef.current = {
                ...lotteryRef.current,
                ...{[data.id]: data}
            }
            setLotteriesToDisplay(Object.values(lotteryRef.current));
        }
    } 

    function getTicketLists() {
        getLotteryDataFromDb({
            "gameId": gameData.gameId,
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            setTicketLists(data);
        }
        function handleListener(unsub) {
            ticketListsListener = unsub;
        }
    }

    return (
        <div className='manage-lottery-landing'>
            <div className='g-card manage-lottery-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <div className='title-with-icon'>
                        <FontAwesomeIcon icon={faTicket} />Lottery Manager
                    </div>
                </div>
                <hr />
                <Routes>
                    <Route path='' element={
                        <LotteryList
                            gameData={gameData}
                            gameElements={gameElements}
                            gameStats={gameStats}
                            playerList={playerList}
                            lotteriesToDisplay={lotteriesToDisplay}
                            ticketLists={ticketLists}
                            />
                    }></Route>
                    <Route path=':lotteryPath' element={
                        <LotteryView
                            gameData={gameData}
                            gameElements={gameElements}
                            gameStats={gameStats}
                            playerList={playerList}
                            lotteriesToDisplay={lotteriesToDisplay}
                            ticketLists={ticketLists} />
                    }></Route>
                </Routes>
            </div>
        </div>
    )
}

export default ManageLotteryLanding